<template>
  <form @submit.prevent="submitAction" class="grid gap-4">
    <ValidationProvider rules="required" name="url" tag="div" vid="url">
      <template #default="{ errors }">
        <BaseFormGroup class="md:w-2/3 lg:w-1/2">
          <BaseFormLabel>Url</BaseFormLabel>
          <BaseFormInput v-model="computedUrl" type="url" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="title" tag="div" vid="title">
      <template #default="{ errors }">
        <BaseFormGroup class="sm:w-1/2 lg:w-1/3">
          <BaseFormLabel>Title</BaseFormLabel>
          <BaseFormInput v-model="computedTitle" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="description" tag="div" vid="description">
      <template #default="{ errors }">
        <BaseFormGroup class="md:w-2/3 lg:w-1/2">
          <BaseFormLabel>Description</BaseFormLabel>
          <BaseFormTextarea v-model="computedDescription" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="grid grid-flow-col gap-2 justify-start">
      <BaseButton primary :disabled="disabled || invalid"> Save </BaseButton>

      <BaseButton type="button" secondary :disabled="disabled" @click="$emit('cancel')">
        Cancel
      </BaseButton>
    </div>
  </form>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    invalid: Boolean,
    disabled: Boolean,
  },

  computed: {
    computedUrl: {
      get() {
        return this.url;
      },
      set(value) {
        this.$emit('update:url', value);
      },
    },
    computedTitle: {
      get() {
        return this.title;
      },
      set(value) {
        this.$emit('update:title', value);
      },
    },
    computedDescription: {
      get() {
        return this.description;
      },
      set(value) {
        this.$emit('update:description', value);
      },
    },
  },

  methods: {
    submitAction() {
      this.$emit('submit');
    },
  },
};
</script>
